/**
 * @description Utility per validazione password
 */

interface ValidationResult {
    ok: boolean;
    errors: string[]
}

/**
 * @description Funzione per validare una password
 * @param password
 * @returns true se la password è valida, false altrimenti
 */
function isValidPassword(password: string): boolean {
    const isLengthValid = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()\[\]{}\\|;:'",<.>/?`~]/.test(password);
    return isLengthValid && hasUpperCase && hasNumber && hasSpecialChar;
}

/**
 * @description Funzione per validare la password di conferma
 * @param password La password da validare
 * @param confirmPassword La password di conferma da confrontare
 * @returns true se le password corrispondono, false altrimenti
 */
function isValidConfirmPassword(password: string, confirmPassword: string): boolean {
    return password === confirmPassword;
}

/**
 * @description Funzione per validare una password
 * @param password La password da validare
 * @returns Un oggetto ValidationResult con esito e dettagli della validazione
 */
export const validatePassword = function validatePassword(password: string): ValidationResult {
    const result: ValidationResult = {
        ok: true,
        errors: []
    };

    // Controllo formato password
    if (!isValidPassword(password)) {
        result.ok = false;
        result.errors.push("La password deve contenere almeno 8 caratteri, una lettera maiuscola, un numero e un carattere speciale.");
    }

    return result;
}

/**
 * @description Funzione per confrontare la password e la password di conferma
 * @param password
 * @param confirmPassword
 * @returns Un oggetto ValidationResult con esito e dettagli della validazione
 */
export const comparePassword = function comparePassword(password: string, confirmPassword: string): ValidationResult {
    const result: ValidationResult = {
        ok: true,
        errors: []
    };

    // Controllo confronto password
    if (!isValidConfirmPassword(password, confirmPassword)) {
        result.ok = false;
        result.errors.push("Le password non corrispondono.");
    }

    return result;
}



